import styled from '@emotion/styled';

export const ContentSection = styled.section`
  width: 100%;
  max-width: calc(100% - 64px);
  height: calc(100vh - 164px);
  max-height: 800px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: #ffffff;
  padding: 32px;
  margin: 32px auto;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const FileSelect = styled.select`
  width: 100%;
  min-width: 250px;
  max-width: 350px;
  height: 44px;
  border-radius: 6px;
  background: #efefef;
  border: 2px solid ${({ hasValue }) => hasValue ? '#009444' : '#efefef'};
  padding: 12px 18px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #000000;
  cursor: pointer;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  option {
    background: #ffffff;
    color: #000000;
  }
`;

export const ColumnSelectGroup = styled.div`
  margin-bottom: 32px;
`;

export const ColumnSelectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ColumnSelectLabel = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const AnalyzeButton = styled.button`
  width: 120px;
  height: 40px;
  border-radius: 6px;
  background: #6A42F2;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: opacity 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const FileStatusBox = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #dddddd;
  display: flex;
  align-items: center;
  padding: 20px;
`;

export const FileStatusText = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColumnConfigGroup = styled.div`
  margin-bottom: 32px;
`;

export const ColumnConfigTitle = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
`;

export const ColumnConfigBox = styled.div`
  width: 100%;
  min-height: 120px;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #dddddd;
  padding: 24px;
`;

export const SelectAllWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #767676;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:checked {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
`;

export const CheckboxLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ColumnItemsTitle = styled.h4`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  margin: 16px 0;
  display: flex;
  align-items: center;
`;

export const ColumnList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const ColumnItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
`;

export const FileNameGroup = styled.div`
  margin-bottom: 24px;
`;

export const FileNameLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 12px;
  display: block;
`;


export const PreviewGroup = styled.div`
  margin-bottom: 0;
`;

export const FileNameInput = styled.input`
  width: 100%;
  height: 34px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  padding: 9px 13px;
  font-family: "Inter", sans-serif;
  font-size: 13.13px;
  line-height: 16px;
  font-weight: 400;
  color: #000000;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #999999;
  }
`;


export const PreviewLabel = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin: 0 0 17px 0;
  width: 56.2px;
  height: 17px;
  display: flex;
  align-items: center;
`;

export const PreviewBox = styled.div`
  width: 100%;
  height: 120px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  overflow: auto;
  padding: 12px;
`;

export const PreviewEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 14px;
`;

export const PreviewTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 12px;
`;

export const PreviewTableHeader = styled.thead`
  background: #f9fafb;
`;

export const PreviewTableHeaderCell = styled.th`
  padding: 8px 12px;
  text-align: left;
  color: #333333;
  font-weight: 600;
  border: 1px solid #e5e7eb;
`;

export const PreviewTableBody = styled.tbody``;

export const PreviewTableCell = styled.td`
  padding: 6px 12px;
  color: #666666;
  border: 1px solid #e5e7eb;
`;

export const PageHeader = styled.header`
  width: 100%;
  padding: 24px 32px;
  background: #ffffff;
  border-bottom: 1px solid #7C3AED;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PageTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
  margin: 0;
`;

export const PageSubtitle = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 4px 0 0 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const RefreshButton = styled.button`
  padding: 8px 16px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover:not(:disabled) {
    background: #e5e7eb;
    border-color: #9ca3af;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;